import { render, staticRenderFns } from "./duplicateReviewPage.vue?vue&type=template&id=bb53f2e4&scoped=true"
import script from "./duplicateReviewPage.vue?vue&type=script&lang=js"
export * from "./duplicateReviewPage.vue?vue&type=script&lang=js"
import style0 from "./duplicateReviewPage.vue?vue&type=style&index=0&id=bb53f2e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb53f2e4",
  null
  
)

export default component.exports